
(() => {
  const MOBILE_MAX = 1149;
  const BODY_CLASS = 'elw-cart-drawer-open';

  const isDrawerOpen = (drawer) => {
    if (!drawer) return false;
    return drawer.hasAttribute('open') || drawer.hasAttribute('opened');
  };

  const sync = () => {
    const drawer = document.getElementById('CartDrawer');
    const mobile = window.innerWidth <= MOBILE_MAX;
    document.body.classList.toggle(BODY_CLASS, mobile && isDrawerOpen(drawer));
  };

  const observeDrawer = () => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    const observer = new MutationObserver(sync);
    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['open', 'opened', 'closing', 'class', 'hidden']
    });

    sync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer, { once: true });
  } else {
    observeDrawer();
  }

  window.addEventListener('resize', sync, { passive: true });

  /* Safety sync for theme drawer events / button interaction timing. */
  document.addEventListener('click', (event) => {
    if (event.target.closest('[aria-controls="CartDrawer"], #CartDrawer')) {
      requestAnimationFrame(() => setTimeout(sync, 30));
    }
  });
})();
